const ProductsTabItemFill = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_512_253)">
                <path
                    d="M14.9668 14.4316L23.2169 22.6817"
                    stroke="#686058"
                    strokeWidth="3.27678"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M3.26911 2.81934C-4.53431 11.2139 16.4259 15.8907 16.4259 15.8907C16.4259 15.8907 2.88814 10.9643 3.26911 2.81934Z"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.38074 2.72082C11.7753 -5.08261 16.4259 15.8907 16.4259 15.8907C16.4259 15.8907 11.5257 2.33985 3.38074 2.72082Z"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.4259 15.8907L3.2691 2.81934"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.62546 14.6681L4.4447 16.8488L9.26601 21.6702L13.5815 17.3481"
                    fill="#686058"
                />
                <path
                    d="M9.06898 22.9378C8.8982 22.9378 8.73399 22.8721 8.60262 22.7473L3.78131 17.926C3.65651 17.8012 3.59082 17.637 3.59082 17.4596C3.59082 17.2823 3.66307 17.118 3.78131 16.9932L5.96206 14.8125C6.21824 14.5563 6.63206 14.5563 6.88823 14.8125C7.1444 15.0687 7.1444 15.4825 6.88823 15.7387L5.17384 17.453L9.06898 21.3482L12.9247 17.4925C13.1809 17.2363 13.5947 17.2363 13.8509 17.4925C14.1071 17.7486 14.1071 18.1624 13.8509 18.4186L9.53535 22.7342C9.40398 22.8655 9.23977 22.9246 9.06898 22.9246V22.9378Z"
                    fill="#686058"
                />
                <path
                    d="M15.7681 5.53207L17.9489 3.35132L22.7702 8.17263L18.4481 12.4882"
                    fill="#686058"
                />
                <path
                    d="M19.0656 12.9413C18.8948 12.9413 18.7306 12.8756 18.5992 12.7508C18.343 12.4946 18.343 12.0808 18.5992 11.8246L22.4549 7.96889L18.5598 4.07374L16.8454 5.78813C16.5892 6.0443 16.1754 6.0443 15.9192 5.78813C15.6631 5.53196 15.6631 5.11814 15.9192 4.86197L18.1 2.68121C18.2248 2.55641 18.389 2.49072 18.5664 2.49072C18.7437 2.49072 18.9079 2.56298 19.0327 2.68121L23.854 7.50252C24.1102 7.75869 24.1102 8.17251 23.854 8.42868L19.5385 12.7442C19.4071 12.8756 19.2429 12.9347 19.0721 12.9347L19.0656 12.9413Z"
                    fill="#686058"
                />
                <path
                    d="M5.64023 19.0555L3.40692 21.2888C2.90114 21.7946 2.90114 22.6157 3.40692 23.1215C3.9127 23.6272 4.73377 23.6272 5.23954 23.1215L7.53853 20.8225"
                    fill="#686058"
                />
                <path
                    d="M5.64023 19.0555L3.40692 21.2888C2.90114 21.7946 2.90114 22.6157 3.40692 23.1215C3.9127 23.6272 4.73377 23.6272 5.23954 23.1215L7.53853 20.8225"
                    stroke="#686058"
                    strokeWidth="1.31071"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.3758 6.05097L24.6091 3.81767C25.1149 3.31189 25.1149 2.49082 24.6091 1.98505C24.1033 1.47927 23.2822 1.47927 22.7765 1.98505L20.4775 4.28404"
                    fill="#686058"
                />
                <path
                    d="M22.3758 6.05097L24.6091 3.81767C25.1149 3.31189 25.1149 2.49082 24.6091 1.98505C24.1033 1.47927 23.2822 1.47927 22.7765 1.98505L20.4775 4.28404"
                    stroke="#686058"
                    strokeWidth="1.31071"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_512_253">
                    <rect
                        width="24.7685"
                        height="24"
                        fill="white"
                        transform="translate(0.871582 0.323242)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ProductsTabItemFill
